import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
var config = {
    apiKey: 'AIzaSyBEqxLrN7mddh082SsJ4ffm4sy4AokUJKg',
    authDomain: 'ssr-website-ad29e.firebaseapp.com',
    databaseURL: 'https://ssr-website-ad29e.firebaseio.com',
    projectId: 'ssr-website-ad29e',
    storageBucket: 'ssr-website-ad29e.appspot.com',
    messagingSenderId: '863343427200'
};
let firebase = Firebase.initializeApp(config);
firebase = firebase.firebase_;
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js